import apiClient from './client';

export interface SendOTPRequest {
  phone: string;
  countryCode?: string;
}

export interface VerifyOTPRequest {
  phone: string;
  otp: string;
  countryCode?: string;
  name?: string;
}

export interface CompleteRegistrationRequest {
  tempToken: string;
  name: string;
  businessName: string;
  email?: string;
  address?: string;
}

export interface SendEmailOTPRequest {
  email: string;
}

export interface VerifyEmailOTPRequest {
  email: string;
  otp: string;
  name?: string;
}

/**
 * The one answer every way of signing in gives: either a session, or a token to
 * finish registering with.
 */
export interface VerifyOTPResponse {
  isNewUser: boolean;
  tempToken?: string;
  /** What Google called them, when that is how they signed in. */
  name?: string;
  user?: AuthResponse['user'];
  token?: string;
  refreshToken?: string;
}

export interface GoogleAuthRequest {
  idToken: string;
  name?: string;
}

export interface AuthResponse {
  user: {
    id: string;
    name?: string;
    phone?: string;
    countryCode?: string;
    email?: string;
    businessName?: string;
    address?: string;
    role: string;
    profilePicture?: string;
  };
  token: string;
  refreshToken: string;
}

export const authApi = {
  sendOTP: async (data: SendOTPRequest) => {
    const response = await apiClient.post('/auth/send-otp', data);
    return response.data;
  },

  verifyOTP: async (data: VerifyOTPRequest) => {
    const response = await apiClient.post<{ data: VerifyOTPResponse }>('/auth/verify-otp', data);
    return response.data.data;
  },

  sendEmailOTP: async (data: SendEmailOTPRequest) => {
    const response = await apiClient.post('/auth/send-email-otp', data);
    return response.data;
  },

  verifyEmailOTP: async (data: VerifyEmailOTPRequest) => {
    const response = await apiClient.post<{ data: VerifyOTPResponse }>('/auth/verify-email-otp', data);
    return response.data.data;
  },

  completeRegistration: async (data: CompleteRegistrationRequest) => {
    const response = await apiClient.post<{ data: AuthResponse }>('/auth/complete-registration', data);
    return response.data.data;
  },

  googleAuth: async (data: GoogleAuthRequest) => {
    const response = await apiClient.post<{ data: VerifyOTPResponse }>('/auth/google', data);
    return response.data.data;
  },

  logout: async (refreshToken: string) => {
    const response = await apiClient.post('/auth/logout', { refreshToken });
    return response.data;
  },
};
